<template>
	<div class="row">
		<div class="col">
			<div class="form-group form__item" :class="{ 'form-group--error': $v.phone.$error}">
				<label class="form__label" for="phone">{{'Phone' | trans}}</label>
				<!--<input v-model="phone" class="form-control" type="text" id="phone" :class="status($v.phone)">-->
				<vue-tel-input @onInput="onInput" class="form-control" :class="status($v.phone)" :only-countries="countries" :default-country="getDefaultCountryCode" id="phone" :showCode="true" :placeholder="''"/>
				<ul class="phone__messages invalid-feedback list-unstyled" v-if="$v.phone.$error">
					<li v-if="!$v.phone.required">
						{{'This field is required' | trans}}
					</li>
				</ul>
				<form-errors :field-name="'phone'" />
			</div>
			<div class="form-group form__item" :class="{ 'form-group--error': $v.password.$error}">
				<label class="form__label" for="password">{{'Password' | trans}}</label>
				<input v-model="password" class="form-control" type="password" id="password" :class="status($v.password)">
				<ul class="password__messages invalid-feedback list-unstyled" v-if="$v.password.$error">
					<li v-if="!$v.password.required">
						{{'This field is required' | trans}}
					</li>
				</ul>
				<form-errors :field-name="'password'" />
				<a class="forgot-pass text-danger"  @click.stop.prevent="resetPassword">
					{{'Forgot Password?' | trans}}
				</a>
			</div>
			<div class="form-group form__item" :class="{ 'form-group--error': $v.termsOfService.$error}">
				<div class="default-checkbox">
					<input v-model="termsOfService" class="form-check-input" value="1" type="checkbox"
					       id="terms_of_service" :class="status($v.termsOfService)">
					<label class="form-check-label" for="terms_of_service">
						<span></span>
						{{'I have read and accepted terms of service' | trans}}
					</label>
				</div>
				<ul class="password__messages invalid-feedback list-unstyled" v-if="$v.termsOfService.$error">
					<li v-if="!$v.termsOfService.required || !$v.termsOfService.mustBeChecked">
						{{'This field is required' | trans}}
					</li>
				</ul>
				<form-errors :field-name="'termsOfService'" />
			</div>
			<div class="form-group form__item">
				<spinner-button :className="'btn btn-danger w-100'" @click.stop.prevent="authenticate"
				                :is-pending="isPendingAuth">
					{{'Login' | trans}}
				</spinner-button>
			</div>
			<div class="mt-3 flex-column d-flex align-items-center">
				{{'Don\'t have an account?' | trans}}
				<a class="btn btn-primary register mt-2" v-bind:href="routeRegister">
					{{'Sign Up' | trans}}
				</a>
			</div>
		</div>
		<!-- the modal -->
		<b-modal v-if="pinModalShow" v-model="pinModalShow" lazy centered hide-footer hide-header>
			<pin-group v-model="pin" :v="$v.pin" :lock="isPendingPin" :hide-pin-button="hidePinButton"
			           @pinDialogSubmit.self.stop.prevent="signIn">
				<template slot="header">
					<p>{{'Enter Your Pin' | trans}}</p>
				</template>
			</pin-group>
		</b-modal>

		<!-- the reset password modal -->
		<b-modal v-if="pinModalResetShow" v-model="pinModalResetShow" lazy centered hide-footer hide-header>
			<pin-input v-model="pin" :v="$v.pin" :lock="isPendingPin" :hide-pin-button="hidePinButton"
			           @resetSubmit.self.stop.prevent="resetPassword">
				<template slot="header">
					<p>{{'Enter Your Pin' | trans}}</p>
				</template>
			</pin-input>
		</b-modal>

		<!-- the verify code modal -->
		<!-- <b-modal v-if="codeModalShow" v-model="codeModalShow" lazy centered hide-footer hide-header>
			<code-verify v-model="code" :v="$v.code" :lock="isPendingCode" :hide-code-button="hideCodeButton"
			           @codeSubmit.self.stop.prevent="resetPassword">
				<template slot="header">
					<p>{{'Enter Your Verify Code' | trans}}</p>
				</template>
			</code-verify>
		</b-modal> -->
	</div>
</template>

<script>
	import './../custom-scripts/vue-tel-input/dist/vue-tel-input.css';
	import PinGroup from "./pin-group";
	import pinInput from "./pin-input";
	import codeVerify from "./code-verify";
	const { required, minLength, maxLength, integer } = require('vuelidate/lib/validators');
	import { validationMixin } from 'vuelidate';
	import getCountryCodes from './../custom-scripts/customCountryList'

	const mustBeChecked = (value) => value === true;

	export default {
		components: {PinGroup,pinInput,codeVerify},
		mixins: [validationMixin],
		props: ['route', 'authenticateRoute', 'routeRestorePassword', 'routeLanding', 'routeRegister'],
		data() {
			return {
				isPendingAuth: false,
				isPendingPin: false,
				phone: '',
				password: '',
				pin: '',
				termsOfService: '',
				pinModalShow: false,
				// codeModalShow: false,
				pinModalResetShow: false,
				hidePinButton: false,
				defaultCountry: 'GN'
			}
		},
		computed: {
			countries() {
				const codes = getCountryCodes(this.$store.state.Application.countries);
				if (codes.length) {
					return codes
				}
			},
			getDefaultCountryCode() {
				return window.countryCode ? window.countryCode : this.defaultCountry
			}
		},
		methods: {
			onInput({number, isValid, country}) {
				this.phone = '00' + country.dialCode + number;
			},
			// async resetPassword() {
			// 	this.codeModalShow = true;
					
			// 		// this.$store.commit(`formErrors/${this.CONSTANTS.MUTATIONS.CLEAR_ERRORS}`);
			// 		// this.isPendingAuth = true;
			// 		// let result = await axios.post(this.resetPasswordRoute, {
			// 		// 	pin: this.pin
			// 		// })
			// 		// 	.then(() => {
			// 		// 		this.pinModalResetShow = true;
			// 		// 	})
			// 		// 	.finally(() => this.isPendingAuth = false);
			// },
			async authenticate() {
				this.$v.$touch();
				if (!this.$v.$invalid) {
					this.isPendingAuth = true;
					this.$store.commit(`formErrors/${this.CONSTANTS.MUTATIONS.CLEAR_ERRORS}`);
					let result = await axios.post(this.authenticateRoute, {
						phone: this.phone,
						password: this.password,
						termsOfService: this.termsOfService
					})
						.then(() => {
							this.pinModalShow = true;
						})
						.finally(() => this.isPendingAuth = false);
				}
			},
			async signIn() {
				this.$v.$touch();
				if (!this.$v.$invalid) {
					this.isPendingPin = true;
					this.$store.commit(`formErrors/${this.CONSTANTS.MUTATIONS.CLEAR_ERRORS}`);
					let result = await axios.post(this.route, {
						phone: this.phone,
						password: this.password,
						pin: this.pin,
						termsOfService: this.termsOfService
					})
						.then(() => {
							this.hidePinButton = true;
							setTimeout(() => window.location.href = this.routeLanding, 1000)
						})
						.finally(() => this.isPendingPin = false);
				}
			}
		},
		validations() {
			let v = {};

			v.phone = {
				required
			};
			v.password = {
				required
			};
			v.termsOfService = {
				required,
				mustBeChecked
			};

			if(this.pinModalShow) {
				v.pin = {
					required,
					minLength: minLength(4),
					maxLength: maxLength(4),
					integer
				}
			}

			if(this.pinModalResetShow) {
				v.pin = {
					required,
					minLength: minLength(4),
					maxLength: maxLength(4),
					integer
				}
			}

			return v;
		}
	}
</script>

<style scoped>
.form-group--error .invalid-feedback {
	display: block;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/login.vue